import { string, z } from 'zod'
import { baseSchema } from './base'

export const buttonSchema = baseSchema
  .extend({
    type: z.literal('button'),
    code: z.string().optional().describe('权限编号'),
    buttonType: z
      .enum(['primary', 'default', 'dashed', 'link', 'text'])
      .optional()
      .describe('按钮类型，影响按钮的显示样式'),
    action: z.enum(['modal', 'download']).optional(),
    text: z.string().optional(),
    data: z.any().optional().describe('自定义数据'),
    method: z.enum(['GET', 'POST']).optional().describe('请求方法，默认 GET'),
    url: string().optional().describe('请求地址'),
    params: z.record(z.string(), z.any()).optional().describe('请求时携带的请求参数'),
    body: z.record(z.string(), z.any()).optional().describe('请求携带的请求体'),
    showLoading: z.boolean().default(true).describe('是否显示加载状态'),
    modal: z
      .object({
        title: z.string(),
        body: z.any().array().optional(),
        data: z.record(z.string(), z.any()).optional(),
        width: z.number().optional(),
      })
      .optional(),
  })
  .refine(
    data => {
      // 当 action 是 'download' 时，url 字段必须存在且不为空
      if (data.action === 'download' && !data.url) {
        return false
      }

      return true
    },
    {
      message: "When action is 'download', 'url' is required.",
      path: ['url'],
    },
  )
  .refine(
    data => {
      // 当 action 是 'dialog' 时，dialog 字段必须存在且不为空
      if (data.action === 'modal' && !data.modal) {
        return false
      }

      return true
    },
    {
      message: "When action is 'modal', 'modal' field is required.",
      path: ['modal'],
    },
  )

export type ButtonSchema = z.infer<typeof buttonSchema>
